import merge from 'lodash/merge';

const backgroundColors = [
  '#37a2eb',
  '#ff6384',
  '#ff9e40',
  '#ffcd56',
  '#4cc0c0',
  '#9a66ff',
  '#c9cbcf',
];

export const dashboardTypes = {
  bar: 'bar',
  line: 'line-chart',
  doughnut: 'doughnut',
  pie: 'pie',
  polarArea: 'polar-area',
  radar: 'radar',
  bubble: 'bubble',
  scatter: 'scatter',
};

function repeatArray(array, n) {
  return [].concat(...Array(n).fill(array));
}

function getBackgroundColors(length) {
  if (length <= backgroundColors.length) {
    return backgroundColors.slice(0, length);
  }

  return repeatArray(backgroundColors, Math.ceil(length / backgroundColors.length)).slice(
    0,
    length,
  );
}

export const updateDatasets = (datasets, options) => {
  const hasLegendPosition = Boolean(options?.plugins?.legend?.position !== 'none');

  return datasets.map((dataset, index) =>
    merge(
      {
        backgroundColor: dataset.data.length ? getBackgroundColors(dataset.data.length) : [],
        ...(hasLegendPosition && { label: `answers ${index + 1}` }),
      },
      dataset,
    ),
  );
};

export const updateChartOptions = (options, { dashboardType, datasetLength } = {}) => {
  const isBarChart = dashboardType === dashboardTypes.bar;
  const hasLegendPosition = Boolean(options?.plugins?.legend?.position !== 'none');
  const isSingleItemBarChart = dashboardType === dashboardTypes.bar && datasetLength <= 1;
  const shouldShowLegend = hasLegendPosition && !isSingleItemBarChart;

  return merge(
    {
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        ...(isBarChart && {
          y: {
            afterFit(scaleInstance) {
              if (options.indexAxis === 'y') {
                scaleInstance.width = 150;
              }
            },
            ticks: {
              callback(value) {
                const maxLineLength = 20;
                const words = this.getLabelForValue(value).toString().split(' ');
                const lines = [];
                let currentLine = '';

                words.forEach((word) => {
                  if (currentLine.length + word.length + 1 <= maxLineLength) {
                    currentLine += (currentLine.length ? ' ' : '') + word;
                  } else {
                    lines.push(currentLine);
                    currentLine = word;
                  }
                });

                lines.push(currentLine);

                return lines;
              },
              autoSkip: false,
              beginAtZero: true,
            },
          },
        }),
      },
      plugins: {
        legend: {
          labels: {
            font: {
              size: 16,
            },
          },
          display: shouldShowLegend,
        },
        title: {
          align: 'start',
          font: {
            size: 20,
            weight: 'normal',
          },
        },
      },
    },
    options,
  );
};
